export const ADD_FOLLOWING = 'ADD_FOLLOWING';
